import { SubmenuType } from '@/config/navigationPages';

export const checkSubMenuActive = (
  subMenu: SubmenuType[],
  locationPathname: string,
): boolean => {
  return subMenu.some((item) => {
    const isItemActive = locationPathname === item.path;

    if (isItemActive) return true;

    if (item.subMenu) {
      const nestedSubMenu = Object.values(item.subMenu);
      return checkSubMenuActive(nestedSubMenu, locationPathname);
    }

    return false;
  });
};

export const checkItemActive = (
  item: SubmenuType,
  locationPathname: string,
): boolean => {
  const isDirectActive = locationPathname === item.path;

  if (isDirectActive) return true;

  if (item.subMenu) {
    const nestedSubMenu = Object.values(item.subMenu);
    return checkSubMenuActive(nestedSubMenu, locationPathname);
  }

  return false;
};
